import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'

export default function AuthValidator ({ children }) {
  const userType = AuthService.getUserType ()
  const isSigned = AuthService.isSigned ()
  const navigate = useNavigate ()

  useEffect (() => {
    if (isSigned && userType === 'professional') {
      updateAccessLevels ()
    }
  }, [isSigned, userType])

  const updateAccessLevels = async () => {
    try {
      const professional = AuthService.getUser ()
      const token = AuthService.getToken ()
      const businessId = AuthService.getBusinessId ()

      const requestConfig = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }

      const [{ data: accessLevels }, { data: permissions }] = await Promise.all ([
        cutileiApi.get (
          `/businesses/${businessId}/professionals/${professional.id}/access_levels`, 
          requestConfig
        ),
        cutileiApi.get (
          `/businesses/${businessId}/professionals/${professional.id}/permissions`,
          requestConfig
        )
      ])

      AuthService.updateUser ({ professional: { ...professional, permissions } })

      if (!accessLevels.some (accessLevel => accessLevel.codename !== 'service')) {
        AuthService.businessSignOut ()
        navigate ('/login', { replace: true })
      }
    } catch (error) {
      logApiError (error)
    }
  }

  return children
}